import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import { defaultGapAnalysisWidgetSupplyData, defaultGapAnalysisWidgetDemandData } from "./DefaultGapAnalysisWidgetData";
import BarChart from "../../charts/BarChart/BarChart";
import TargetChart from "../../charts/TargetChart/TargetChart";
import SlidingPanel from "../../SlidingPanel/SlidingPanel";
import SlidingPanelContent from "../../SlidingPanelContent/SlidingPanelContent";
import SlidingPanelWidget from "../../SlidingPanelWidget/SlidingPanelWidget";
import Collapsible from "../../Collapsible";
import PageBreak from "../../PageBreak";

function fillMissingLabels(labels, data) {

  // if( data.labels.length === labels.length) return data;

  let newBarsData = {};
  for (let k of Object.keys(data.series.barsData)) {
    newBarsData[k] = [];
  };
  let newDotsData = {};
  for (let k of Object.keys(data.series.dotsData)) {
    newDotsData[k] = [];
  };

  for (let label of labels) {
    let index = data.labels.indexOf(label);
    if (index > -1) {
      for (const [k, v] of Object.entries(data.series.barsData)) {
        newBarsData[k].push(v[index]);
      };
      for (const [k, v] of Object.entries(data.series.dotsData)) {
        newDotsData[k].push(v[index]);
      };
    }
    else {
      Object.keys(newBarsData).forEach(k => {
        newBarsData[k].push(0);
      });
      Object.keys(newDotsData).forEach(k => {
        newDotsData[k].push(0);
      });
    };
  };

  let finalData = {
    labels,
    series: {
      barsData: newBarsData,
      dotsData: newDotsData
    }
  };

  return finalData;
};

function sumArraysByPosition(arrays) {
  let finalArray = [];
  let size = 0;

  for (let k in arrays) {
    size = arrays[k].length;
    for (let i = 0; i < size; i++) {
      if (!finalArray[i]) {
        finalArray[i] = 0;
      }
      finalArray[i] += arrays[k][i];
    }
  }
  return finalArray;
}

function calculateGaps(supply, demand) {
  //demand - supply
  let finalArray = [];
  demand.forEach((d, i) =>
    finalArray[i] = demand[i] - supply[i]
  );
  return finalArray;
}

// function calculateQuotients(num, den) {
//   let finalArray = [];
//   num.forEach((d, i) =>
//     finalArray[i] = num[i] / den[i]
//   );
//   return finalArray;
// }

const GapAnalysisWidget = ({ endpoint, datasource, requestHandler, title, tooltips, filter, profileId, solutionId, subtitle,
  showTitle = [], chartClassName, options = [], locale = navigator.language, labels, logo, alt, disableRls=false }) => {

  const [demandData, setDemandData] = useState(defaultGapAnalysisWidgetDemandData);
  const [supplyData, setSupplyData] = useState(defaultGapAnalysisWidgetSupplyData);
  const [error, setError] = useState("");

  const targetOptions = options[0];
  const barsOptions = options[1];
  // const dotsOptions = options[2];

  // const showTitle_0 = showTitle[0];
  const showTitle_1 = showTitle[1];
  const showTitle_2 = showTitle[2];
  const showTitle_3 = showTitle[3];
  // const showTitle_4 = showTitle[4];

  const [endpoint1, endpoint2] = endpoint;
  const [datasource1, datasource2] = datasource;
  const [filter1, filter2] = filter;

  useEffect(() => {
    requestHandler(endpoint1, datasource1, filter1, profileId, solutionId, setSupplyData, setError, disableRls);
  }, [endpoint1, datasource1, filter1, profileId, solutionId, disableRls]);

  useEffect(() => {
    requestHandler(endpoint2, datasource2, filter2, profileId, solutionId, setDemandData, setError, disableRls);
  }, [endpoint2, datasource2, filter2, profileId, solutionId, disableRls]);

  const finalSupplyData = fillMissingLabels(labels, supplyData);
  const finalDemandData = fillMissingLabels(labels, demandData);
  const supplyTotalsBars = sumArraysByPosition(finalSupplyData.series.barsData);
  const supplyTotalsDots = sumArraysByPosition(finalSupplyData.series.dotsData);
  const demandTotalsBars = sumArraysByPosition(finalDemandData.series.barsData);
  const demandTotalsDots = sumArraysByPosition(finalDemandData.series.dotsData);
  const gaps = calculateGaps(supplyTotalsBars, demandTotalsBars);
  // const lqs = calculateQuotients(demandTotalsBars, demandTotalsDots);
  // const sqs = calculateQuotients(supplyTotalsBars, supplyTotalsDots);

  return (
    <>
      <Row className="d-block d-xl-flex align-items-center">
        <Col xs={12} className="px-xl-0">
          <h4 className="mb-1">{error ? "Service unavailable" : title[0]}</h4>
          <h5 className="mb-1">{subtitle[0]}</h5>
        </Col>
      </Row>
      <Row className="justify-content-md-center mb-4">
        <Collapsible title={title[1]}>
          <SlidingPanel slidingPanelName="supplySLide">
            <SlidingPanelContent>
              <div>
                <h3>{title[1]}</h3>
                <p>{tooltips[0]}</p>
              </div>
            </SlidingPanelContent>
            <SlidingPanelWidget>
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Row className="h-25 d-block d-xl-flex align-items-center">
                    {(showTitle_1) &&
                      <Col xs={12} className="px-xl-0">
                        <h5 className="mb-2">{title[1]}</h5>
                      </Col>
                    }
                    <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
                      <h6 className="mt-1 mb-1">{subtitle[1]}</h6>
                    </Col>
                    <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
                      <TargetChart
                        labels={finalSupplyData.labels}
                        series={[supplyTotalsBars, supplyTotalsDots]}
                        chartClassName={chartClassName}
                        options={targetOptions}
                        locale={locale}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </SlidingPanelWidget>
          </SlidingPanel>
        </Collapsible>
      </Row>
      <PageBreak logo={logo} alt={alt} />
      <Row className="justify-content-md-center mb-4">
        <Collapsible title={title[2]}>
          <SlidingPanel slidingPanelName="demandSlide">
            <SlidingPanelContent>
              <div>
                <h3>{title[2]}</h3>
                <p>{tooltips[1]}</p>
              </div>
            </SlidingPanelContent>
            <SlidingPanelWidget>
                <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Row className="h-25 d-block d-xl-flex align-items-center">
                    {(showTitle_2) &&
                      <Col xs={12} className="px-xl-0">
                        <h5 className="mb-2">{title[2]}</h5>
                      </Col>
                    }
                    <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
                      <h6 className="mt-3 mb-1">{subtitle[2]}</h6>
                    </Col>
                    <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
                      <TargetChart
                        labels={finalDemandData.labels}
                        series={[demandTotalsBars, demandTotalsDots]}
                        chartClassName={chartClassName}
                        options={targetOptions}
                        locale={locale}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </SlidingPanelWidget>
          </SlidingPanel>
        </Collapsible>
      </Row>
      <PageBreak logo={logo} alt={alt} />
      <Row className="justify-content-md-center mb-4">
        <Collapsible title={title[3]}>
          <SlidingPanel slidingPanelName="gapSlide">
            <SlidingPanelContent>
              <div>
                <h3>{title[3]}</h3>
                <p>{tooltips[2]}</p>
              </div>
            </SlidingPanelContent>
            <SlidingPanelWidget>
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Row className="h-25 d-block d-xl-flex align-items-center">
                    {(showTitle_3) &&
                      <Col xs={12} className="px-xl-0">
                        <h5 className="mb-2">{title[3]}</h5>
                      </Col>
                    }
                    <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
                      <h6 className="mt-1 mb-1">{subtitle[3]}</h6>
                    </Col>
                    <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
                      <BarChart
                        labels={finalSupplyData.labels}
                        series={[gaps]}
                        chartClassName={chartClassName}
                        options={{ ...barsOptions, low: Math.min(...gaps) - 100 }}
                        locale={locale}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </SlidingPanelWidget>
          </SlidingPanel>
          
          
        </Collapsible>
      </Row>
      {/* <Row className="justify-content-md-center mb-4">
        <Collapsible title={title[4]}>
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <Row className="h-25 d-block d-xl-flex align-items-center">
                {(showTitle_4) &&
                  <Col xs={12} className="px-xl-0">
                    <h5 className="mb-2">{title[4]}</h5>
                  </Col>
                }
                <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
                  <h6 className="mt-1 mb-1">{subtitle[4]}</h6>
                </Col>
                <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
                  <DotsChart
                    labels={finalDemandData.labels}
                    series={[lqs, sqs]}
                    chartClassName={chartClassName}
                    options={dotsOptions}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Collapsible>
      </Row> */}
    </>
  );
};

export default GapAnalysisWidget;